import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { CREATE_USER_FORM_ANSWER } from '../../../apollo';

interface UserFormAnswerInput {
  questionId: number;
  statement?: string;
  entityId: number;
  choices: {
    placement?: number;
    questionChoiceId: number;
  }[];
}

type CreateUserFormAnswerEffectReturn = {
  createUserFormAnswer: (contact: UserFormAnswerInput) => void;
  loading: boolean;
  success: boolean;
  error: string | undefined;
};

export const useCreateUserFormAnswerEffect = (
  callback?: (data?: any) => void
): CreateUserFormAnswerEffectReturn => {
  const [success, setSuccess] = useState(false);

  const [doCreateUserFormAnswer, { loading, error }] = useMutation(
    CREATE_USER_FORM_ANSWER,
    {
      onCompleted: (data) => {
        setSuccess(true);
        if (callback) {
          callback(data.createUserFormAnswer);
        }
      },
    }
  );

  const createUserFormAnswer = (data: UserFormAnswerInput): void => {
    const variables = { data: { ...data, entityType: 'CONTACT' } };

    doCreateUserFormAnswer({ variables }).then();
  };

  return {
    createUserFormAnswer,
    loading,
    success,
    error: error?.message,
  };
};
